import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'app-register',
    imports: [
        FormsModule,
    ],
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent {
  token: string | null = null
  linkExpired = false
  lastSuccess = false
  password = ''
  vpassword = ''
  email = ''
  error: string | null = null;

  constructor(private route: ActivatedRoute, private auth: AuthService,private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'] || null
      console.log(Object.keys(params))

      if (this.token) {
        this.auth.checkRegistrationToken(this.token).subscribe({
          next: result => {
            // success
            console.log("Why do things" + this.token)
          },
          error: error => {
            this.linkExpired = true
          }
        })
      }
    })
  }

  resetPassword() {
    if (this.token)
    this.auth.resetPassword(this.token, this.email, this.password, this.vpassword).subscribe({
        next: login => {
          if (this.auth.isAuthenticated()) {
            this.lastSuccess = true
            this.router.navigate([login.redirect])
            this.error = null
          } else {
            this.error = "Not authenticated"
          }
        }, 
        error: error => { 
          console.log(error)
          this.error = error
        }
      })

  }

}
